import styled, { css } from 'styled-components';
import { Button, Modal } from 'src/components';

export const ModalTitle = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.s};
    color: ${theme.co.secondary20};
    margin-bottom: ${theme.sz.s6};
  `,
);

export const PricesModal = styled(Modal)(
  ({ theme }) => css`
    @media (max-width: ${theme.sz.xl}) {
      .reactModalOverlay {
        align-items: flex-end;
        padding: 0;
      }

      .reactModalContent {
        border-radius: 0;
        overflow: hidden;
        margin: 0;
        position: fixed;
        bottom: 0;
        padding: ${theme.sz.s8} ${theme.sz.s6} ${theme.sz.s6};
        max-width: 100%;
      }
    }
  `,
);

export const CtaButton = styled(Button)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s4};
  `,
);
